/* ==========================================================================
   nomni theme — theme.js
   Vanilla JS, no dependencies. Progressive enhancement only:
   the storefront works without JS (native forms + links).
   ========================================================================== */
(function () {
  'use strict';

  /* ----- Mobile nav -------------------------------------------------------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ----- Quantity steppers ------------------------------------------------- */
  function initQtySteppers() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('[data-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-change'), 10);
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var val = parseInt(input.value, 10) || min;
          val = Math.max(min, val + step);
          input.value = val;
          // If this stepper auto-submits (cart page), fire change for native handlers.
          if (wrap.hasAttribute('data-qty-autosubmit')) {
            input.dispatchEvent(new Event('change', { bubbles: true }));
            var form = input.closest('form');
            if (form) form.submit();
          }
        });
      });
    });
  }

  /* ----- Product variant selection + gallery ------------------------------- */
  function initProduct() {
    var root = document.querySelector('[data-product]');
    if (!root) return;

    var variantsEl = root.querySelector('[data-variants]') || document.querySelector('[data-variants]');
    var variants = [];
    if (variantsEl) {
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }
    }

    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var skuWrap = root.querySelector('[data-sku-wrap]');
    var skuEl = root.querySelector('[data-sku]');
    var mainImg = root.querySelector('[data-main-image]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var optionSelects = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));

    function currentSelection() {
      return optionSelects.map(function (sel) { return sel.value; });
    }

    function findVariant(selection) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selection[i]; });
      });
    }

    function setMainImage(url) {
      if (mainImg && url) {
        mainImg.src = url;
        mainImg.srcset = '';
      }
    }

    function setActiveThumb(thumb) {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      if (thumb) thumb.classList.add('is-active');
    }

    function update(userTriggered) {
      if (!variants.length) return;
      var variant = optionSelects.length ? findVariant(currentSelection()) : variants[0];

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-unavailable'); }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl && variant.price_html) priceEl.innerHTML = variant.price_html;

      if (skuWrap) {
        if (variant.sku) {
          if (skuEl) skuEl.textContent = variant.sku;
          skuWrap.hidden = false;
        } else {
          skuWrap.hidden = true;
        }
      }

      if (variant.media_url) {
        setMainImage(variant.media_url);
        setActiveThumb(thumbs.filter(function (t) {
          return t.getAttribute('data-media-id') === String(variant.media_id);
        })[0]);
      }

      // Keep the URL shareable/refreshable for the selected variant.
      if (userTriggered && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-add');
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-soldout');
        }
      }
    }

    optionSelects.forEach(function (sel) {
      sel.addEventListener('change', function () { update(true); });
    });
    update(false);

    // Gallery thumbnails
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setMainImage(thumb.getAttribute('data-full'));
        setActiveThumb(thumb);
      });
    });
  }

  /* ----- Accordions -------------------------------------------------------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) panel.hidden = expanded;
      });
    });
  }

  /* ----- Draggable auto-scroll marquee ------------------------------------- */
  /* Container natively scrolls (overflow-x), JS auto-advances it, and pointer
     drag scrubs it. Content is rendered twice, so we wrap at one-copy width for
     a seamless loop. Touch uses native scroll (momentum); mouse uses drag. */
  function initMarquees() {
    document.querySelectorAll('[data-marquee]').forEach(function (el) {
      var track = el.querySelector('[data-marquee-track]');
      if (!track || !window.requestAnimationFrame) return;

      var duration = parseFloat(el.getAttribute('data-marquee-duration')) || 80;
      var pauseHover = el.hasAttribute('data-marquee-pause-hover');
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Width of one duplicated copy (handles gaps/padding correctly).
      function loopWidth() {
        var items = track.children;
        var half = Math.floor(items.length / 2);
        if (items.length < 2 || half < 1) return 0;
        return items[half].offsetLeft - items[0].offsetLeft;
      }

      function normalize() {
        var lw = loopWidth();
        if (lw <= 0) return;
        if (el.scrollLeft >= lw) el.scrollLeft -= lw;
        else if (el.scrollLeft < 0) el.scrollLeft += lw;
      }

      var dragging = false, mouseDrag = false, hovering = false;
      var startX = 0, startScroll = 0, lastT = null;

      function tick(t) {
        if (lastT === null) lastT = t;
        var dt = (t - lastT) / 1000;
        lastT = t;
        var advancing = !dragging && !reduceMotion && !(pauseHover && hovering);
        if (advancing) {
          var lw = loopWidth();
          if (lw > 0) el.scrollLeft += (lw / duration) * dt;
        }
        normalize();
        window.requestAnimationFrame(tick);
      }

      if (pauseHover) {
        el.addEventListener('mouseenter', function () { hovering = true; });
        el.addEventListener('mouseleave', function () { hovering = false; });
      }

      el.addEventListener('pointerdown', function (e) {
        dragging = true;
        el.classList.add('is-dragging');
        lastT = null;
        if (e.pointerType === 'mouse') {
          mouseDrag = true;
          startX = e.clientX;
          startScroll = el.scrollLeft;
          try { el.setPointerCapture(e.pointerId); } catch (_) {}
          e.preventDefault();
        } else {
          mouseDrag = false; // touch/pen: let native scroll move it
        }
      });
      el.addEventListener('pointermove', function (e) {
        if (dragging && mouseDrag) {
          el.scrollLeft = startScroll - (e.clientX - startX);
          normalize();
        }
      });
      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        mouseDrag = false;
        el.classList.remove('is-dragging');
        lastT = null;
        if (e && e.pointerId != null) { try { el.releasePointerCapture(e.pointerId); } catch (_) {} }
      }
      el.addEventListener('pointerup', endDrag);
      el.addEventListener('pointercancel', endDrag);
      el.addEventListener('dragstart', function (e) { e.preventDefault(); });

      window.requestAnimationFrame(tick);
    });
  }

  /* ----- Live cart count (refresh from /cart.js) --------------------------- */
  function initCartCount() {
    var el = document.querySelector('[data-cart-count]');
    if (!el || !window.fetch) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var count = cart.item_count || 0;
        el.textContent = count;
        el.hidden = count === 0;
      })
      .catch(function () { /* non-critical */ });
  }

  /* ----- Collection keyword filter + mobile sidebar toggle ----------------- */
  function initCollectionFilter() {
    var input = document.getElementById('collection-keyword-filter');
    var grid = document.getElementById('collection-product-grid');
    var noResults = document.getElementById('collection-no-results');
    var countEl = document.getElementById('collection-count');
    var sortForm = document.getElementById('collection-sort-form');
    var filterToggle = document.querySelector('[data-filter-toggle]');
    var sidebar = document.getElementById('collection-sidebar');

    if (!grid) return;

    var items = grid.querySelectorAll('[data-filter-item]');
    var totalCount = items.length;

    var instockCheckbox = document.getElementById('collection-instock-filter');

    function applyFilters() {
      var query = input ? input.value.trim().toLowerCase() : '';
      var instockOnly = instockCheckbox ? instockCheckbox.checked : false;
      var visible = 0;

      items.forEach(function (item) {
        var title = item.getAttribute('data-title') || '';
        var available = item.getAttribute('data-available') !== 'false';
        var matchesKeyword = query === '' || title.indexOf(query) !== -1;
        var matchesStock = !instockOnly || available;
        var matches = matchesKeyword && matchesStock;
        item.hidden = !matches;
        if (matches) visible++;
      });

      if (noResults) noResults.hidden = visible > 0;

      if (countEl) {
        var filtered = query !== '' || instockOnly;
        if (!filtered) {
          countEl.textContent = totalCount + (totalCount === 1 ? ' product' : ' products');
        } else {
          countEl.textContent = visible + ' of ' + totalCount + (totalCount === 1 ? ' product' : ' products');
        }
      }
    }

    if (input) {
      input.addEventListener('input', applyFilters);
    }

    if (instockCheckbox) {
      instockCheckbox.addEventListener('change', applyFilters);
    }

    if (sortForm) {
      sortForm.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          sortForm.submit();
        });
      });
    }

    if (filterToggle && sidebar) {
      filterToggle.addEventListener('click', function () {
        var open = sidebar.classList.toggle('is-open');
        filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initQtySteppers();
    initProduct();
    initAccordions();
    initMarquees();
    initCartCount();
    initCollectionFilter();
  });
})();
